package net.frozenbit.games.soundgame

import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.ui.ExperimentalComposeUiApi
import androidx.compose.ui.window.ComposeViewport
import kotlinx.browser.window
import net.frozenbit.games.soundgame.audio.AudioManager
import net.frozenbit.games.soundgame.audio.MusicManager
import net.frozenbit.games.soundgame.audio.WebAudioPlayer

@OptIn(ExperimentalComposeUiApi::class)
fun main() {
    val isDesktop = window.innerWidth >= 1024
    ComposeViewport {
        if (isDesktop) {
            val audioPlayer = WebAudioPlayer()
            val musicManager = MusicManager(
                audioPlayer,
                rememberCoroutineScope(),
            )
            HostApp(
                keyValueStore = LocalStorageKeyValueStore,
                sessionKeyValueStore = SessionStorageKeyValueStore,
                audioManager = AudioManager(
                    audioPlayer,
                    musicManager,
                    rememberCoroutineScope(),
                ),
                musicManager = musicManager,
            )
        } else {
            ControllerApp(keyValueStore = LocalStorageKeyValueStore)
        }
    }
}